import { HttpEvent, HttpRequest, HttpInterceptorFn, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { TranslationSandbox } from '@app/core/sandboxes/translation.sandbox';

export const cultureCodeInterceptor: HttpInterceptorFn = (
  httpRequest: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const culture = inject(TranslationSandbox)?.getCulture();

  if (!culture?.cultureCode) {
    return next(httpRequest);
  }

  return next(
    httpRequest.clone({
      setHeaders: { 'x-hohr-culture-code': culture?.cultureCode },
    })
  );
};
